import { Outlet } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import AnnouncementBanner from "./AnnouncementBanner";
import Cart from "./Cart";
import { CartProvider } from "../lib/cart";

export default function Layout() {
  return (
    <CartProvider>
      <div className="min-h-screen flex flex-col bg-demolition-black">
        <AnnouncementBanner />
        <Navigation />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <Cart />
      </div>
    </CartProvider>
  );
}
